import jsonwebtoken from 'jsonwebtoken'
import store from '../store/index.js'

const loggedIn = 'loggedIn'
const tokenExpiryKey = 'tokenExpiry'
const jwtToken = 'accessToken'

const authService = {

  logOut() {
    sessionStorage.removeItem(loggedIn)
    localStorage.removeItem(tokenExpiryKey)
    sessionStorage.removeItem('userData')

    store.state.user.loggedIn = false
    store.state.user.userData = null
  },

  setLoginParameters(token) {
    sessionStorage.setItem(loggedIn, 'true')
    localStorage.setItem(jwtToken, token)
    store.state.user.loggedIn = true
  },
  getDecodedJWT() {
    const jwt = localStorage.getItem(jwtToken)
    const decoded = jsonwebtoken.decode(jwt)

    return decoded
  },

  isAuthenticated() {
    const jwt = localStorage.getItem(jwtToken)
    const decoded = jsonwebtoken.decode(jwt)

    return (
      jwt
      && new Date(Date.now()) < new Date(decoded.validUntil)
      && sessionStorage.getItem(loggedIn) === 'true'
    )
  }

}

export default authService
